export const ROUTE_NAMES = {
    CARD_ACTIVATION: 'CARD_ACTIVATION',
    CARD_ACTIVATION_SET_PIN: 'CARD_ACTIVATION_SET_PIN',
    RESET_PIN: 'RESET_PIN',
    CARD_INFO: 'CARD_INFO',
    CARD_INFO_SET_PIN: 'CARD_INFO_SET_PIN',
    STATUS: 'STATUS',
};

export const ROUTE_PATHS = {
    [ROUTE_NAMES.CARD_ACTIVATION]: '/card-activation',
    [ROUTE_NAMES.CARD_ACTIVATION_SET_PIN]: '/card-activation/set-pin',
    [ROUTE_NAMES.RESET_PIN]: '/reset-pin',
    [ROUTE_NAMES.CARD_INFO]: '/card-info',
    [ROUTE_NAMES.CARD_INFO_SET_PIN]: '/card-info/set-pin',
    [ROUTE_NAMES.STATUS]: '/status',
};

export const PATHS_TO_NAMES = {
    [ROUTE_PATHS.CARD_ACTIVATION]: ROUTE_NAMES.CARD_ACTIVATION,
    [ROUTE_PATHS.CARD_ACTIVATION_SET_PIN]: ROUTE_NAMES.CARD_ACTIVATION_SET_PIN,
    [ROUTE_PATHS.RESET_PIN]: ROUTE_NAMES.RESET_PIN,
    [ROUTE_PATHS.CARD_INFO]: ROUTE_NAMES.CARD_INFO,
    [ROUTE_PATHS.CARD_INFO_SET_PIN]: ROUTE_NAMES.CARD_INFO_SET_PIN,
    [ROUTE_PATHS.STATUS]: ROUTE_NAMES.STATUS,
};
